import ReportTableRowValues from './ReportTableRowValues'
import { connect } from 'react-redux'

const mapStateToProps = state => {
    return {
        yearsEvolution: state.FILTERS.evolutionFilter
    }
  }
  
export default connect(mapStateToProps)(ReportTableRowValues)


// WEBPACK FOOTER //
// ./src/modules/Charts/ReportTableRow/ReportTableRowValues/index.js